import { SharedState } from '@trello/shared-state';

export const ajaxState = new SharedState<{
  isPolling: boolean;
  pollRequestFailures: number;
}>({
  isPolling: false,
  pollRequestFailures: 0,
});
